import { InjectionToken } from '@angular/core';

/**
 * InjectionToken used to retrieve the base href of the webpage.
 */
export const BASE_HREF = new InjectionToken<string>('BASE_HREF', {
  providedIn: 'root',
  factory: () => document.getElementsByTagName('base')[0].href
});
